import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

const FARBEN = ['#6366f1','#10b981','#ef4444','#f59e0b','#3b82f6','#ec4899','#8b5cf6','#06b6d4'];
const ICONS = ['🛒','🏪','🥦','🍖','🧹','💊','🏠','🎁','🐾','🍰'];

export default function ListenPage() {
  const [listen, setListen] = useState([]);
  const [zeigForm, setZeigForm] = useState(false);
  const [form, setForm] = useState({ name: '', icon: '🛒', farbe: '#6366f1' });
  const navigate = useNavigate();

  useEffect(() => { laden(); }, []);

  async function laden() {
    const r = await api.get('/listen');
    setListen(r.data);
  }

  async function erstellen(e) {
    e.preventDefault();
    await api.post('/listen', form);
    setZeigForm(false);
    setForm({ name: '', icon: '🛒', farbe: '#6366f1' });
    laden();
  }

  async function loeschen(id) {
    if (!window.confirm('Liste löschen?')) return;
    await api.delete(`/listen/${id}`);
    laden();
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <h1 style={{ margin: 0, fontSize: '22px', fontWeight: '700' }}>📋 Meine Listen</h1>
        <button onClick={() => setZeigForm(true)} style={{ padding: '10px 16px', background: '#6366f1', color: 'white', border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: '600' }}>+ Neue Liste</button>
      </div>

      {listen.length === 0 && !zeigForm && (
        <div style={{ textAlign: 'center', padding: '60px 20px', color: '#94a3b8' }}>
          <div style={{ fontSize: '64px', marginBottom: '12px' }}>🛒</div>
          <div style={{ fontSize: '16px', marginBottom: '8px' }}>Noch keine Listen</div>
          <div style={{ fontSize: '13px' }}>Erstelle deine erste Einkaufsliste!</div>
        </div>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {listen.map(l => (
          <div key={l.id} onClick={() => navigate(`/liste/${l.id}`)}
            style={{ background: 'white', borderRadius: '14px', padding: '16px 20px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderLeft: `4px solid ${l.farbe}`, cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <span style={{ fontSize: '28px' }}>{l.icon}</span>
              <div>
                <div style={{ fontWeight: '700', fontSize: '16px' }}>{l.name}</div>
                <div style={{ color: '#64748b', fontSize: '12px' }}>{new Date(l.erstellt_am).toLocaleDateString('de-DE')}</div>
              </div>
            </div>
            <button onClick={e => { e.stopPropagation(); loeschen(l.id); }}
              style={{ background: '#fee2e2', border: 'none', borderRadius: '8px', padding: '6px 10px', cursor: 'pointer', color: '#ef4444' }}>🗑️</button>
          </div>
        ))}
      </div>

      {zeigForm && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'flex-end', zIndex: 100 }}>
          <div style={{ background: 'white', borderRadius: '20px 20px 0 0', padding: '24px', width: '100%', maxWidth: '600px', margin: '0 auto' }}>
            <h2 style={{ margin: '0 0 16px', fontSize: '18px' }}>➕ Neue Liste</h2>
            <form onSubmit={erstellen}>
              <input value={form.name} onChange={e => setForm({...form, name: e.target.value})}
                placeholder="Listenname" required
                style={{ width: '100%', padding: '12px', border: '1px solid #e2e8f0', borderRadius: '10px', fontSize: '15px', marginBottom: '12px', boxSizing: 'border-box' }} />
              <div style={{ marginBottom: '12px' }}>
                <label style={{ fontSize: '13px', fontWeight: '600', color: '#374151', display: 'block', marginBottom: '8px' }}>Icon</label>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                  {ICONS.map(i => <button key={i} type="button" onClick={() => setForm({...form, icon: i})}
                    style={{ fontSize: '22px', padding: '6px', border: `2px solid ${form.icon === i ? '#6366f1' : '#e2e8f0'}`, borderRadius: '8px', background: 'white', cursor: 'pointer' }}>{i}</button>)}
                </div>
              </div>
              <div style={{ marginBottom: '16px' }}>
                <label style={{ fontSize: '13px', fontWeight: '600', color: '#374151', display: 'block', marginBottom: '8px' }}>Farbe</label>
                <div style={{ display: 'flex', gap: '8px' }}>
                  {FARBEN.map(f => <button key={f} type="button" onClick={() => setForm({...form, farbe: f})}
                    style={{ width: '32px', height: '32px', borderRadius: '50%', background: f, border: `3px solid ${form.farbe === f ? '#1e293b' : 'transparent'}`, cursor: 'pointer' }} />)}
                </div>
              </div>
              <div style={{ display: 'flex', gap: '10px' }}>
                <button type="button" onClick={() => setZeigForm(false)}
                  style={{ flex: 1, padding: '12px', background: '#f1f5f9', border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: '600' }}>Abbrechen</button>
                <button type="submit"
                  style={{ flex: 2, padding: '12px', background: '#6366f1', color: 'white', border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: '700' }}>✅ Erstellen</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
